mutation completeWithdrawalSwapTransaction($eth_address: String!, $id: String!, $tx_hash: String!) {
  completeWithdrawalSwapTransaction(eth_address: $eth_address, id: $id, tx_hash: $tx_hash)
}
